var _circle, _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndonesia({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1992,
    cy: 11.7832,
    r: 11.0992,
    fill: "#E20418",
    stroke: "#D8D8D8",
    strokeWidth: 0.2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_2323_179144",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 11.7832C0 13.2539 0.289677 14.7102 0.852489 16.069C1.4153 17.4277 2.24023 18.6623 3.28018 19.7022C4.32012 20.7422 5.55471 21.5671 6.91346 22.1299C8.27222 22.6927 9.72852 22.9824 11.1992 22.9824C12.6699 22.9824 14.1262 22.6927 15.485 22.1299C16.8437 21.5671 18.0783 20.7422 19.1183 19.7022C20.1582 18.6623 20.9831 17.4277 21.5459 16.069C22.1088 14.7102 22.3984 13.2539 22.3984 11.7832L11.1992 11.7832H0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.7832C0 13.2539 0.289677 14.7102 0.852489 16.069C1.4153 17.4277 2.24023 18.6623 3.28018 19.7022C4.32012 20.7422 5.55471 21.5671 6.91346 22.1299C8.27222 22.6927 9.72852 22.9824 11.1992 22.9824C12.6699 22.9824 14.1262 22.6927 15.485 22.1299C16.8437 21.5671 18.0783 20.7422 19.1183 19.7022C20.1582 18.6623 20.9831 17.4277 21.5459 16.069C22.1088 14.7102 22.3984 13.2539 22.3984 11.7832L11.1992 11.7832H0Z",
    fill: "#F2F2F2",
    stroke: "#D8D8D8",
    strokeWidth: 0.4,
    mask: "url(#path-2-inside-1_2323_179144)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndonesia);
export default __webpack_public_path__ + "static/media/Indonesia.afd9e3960c980326d49535ab88f2c3f7.svg";
export { ForwardRef as ReactComponent };